import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseCrudComponent } from '@app/admin/base-crud.component';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { State, DataResult } from '@progress/kendo-data-query';
import { RoleContextmenuComponent } from '@app/core/components/contextmenus';
import { CreateEditRoleComponent, EditRolePermissionsComponent } from '@app/core/windows'; 


@Component({
  selector: 'roles-crud',
  templateUrl: './roles-crud.component.html',
  providers: [ DatasourceService ]
})
export class RolesCrudComponent extends BaseCrudComponent implements OnInit {

  //Window
  @ViewChild(CreateEditRoleComponent, {static: false}) window !: CreateEditRoleComponent;

  //Permisos
  @ViewChild(EditRolePermissionsComponent, {static: false}) permissions !: EditRolePermissionsComponent;

  //Menu
  @ViewChild(RoleContextmenuComponent, {static: false}) menu_rol !: RoleContextmenuComponent;

  protected menu: string = 'Acceso';

  protected menuIcon: string = 'gears';
  
  protected label: string = 'Rol';

  protected name: string = 'Roles';

  protected table: string = 'roles';
  
  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService) {
    
    super(authService, service, alertService);
    console.log(this.constructor.name);
    this.breadcrumbItems = this.getBreadcumItems();

  }  

  //Overrides
  protected getInitialState() : State {

    let s = this.service.getStateEmpty();
    s.sort = [      
      {field: 'name', dir: 'asc'}
    ];

    return s;

  }

  public onClick(e: any) : void {

      console.log(e);
      // const originalEvent = e.originalEvent;
      // originalEvent.preventDefault();
      // this.contextItem = e.dataItem;
      // this.gridContextMenu.show({ left: originalEvent.pageX, top: originalEvent.pageY });

  }

  public onCellClick(e: any): void {
      
    console.log(e);
    if (e.type === 'contextmenu') {
      const originalEvent = e.originalEvent;
      originalEvent.preventDefault();
      // this.menu_proy.label = 'Folio consecutivo: ' + e.dataItem.folio_consecutivo;
      this.menu_rol.contextItem = e.dataItem;
      this.menu_rol.menu.show({ left: originalEvent.pageX, top: originalEvent.pageY });
    }

  }

  public dblClickEvent(e : any) : void {

    // console.log('dblClickEvent', e);
    if (e.path[1].nodeName === 'TR') {
      let index = e.path[1].rowIndex;
      let data : DataResult = this.grid.data as DataResult;
      this.permissions.edit(data.data[index]);
    }

  }

  public selectMenu({ menu, contextItem }): void {
    
    // console.log("selectMenu", menu, contextItem);

    if (menu.url === 'editar') {

      this.window.label = this.label;
      this.window.table = this.table;
      this.window.edit(contextItem);

    } else if (menu.url === 'eliminar') {
        
      this.removeHandler({dataItem: contextItem});

    } else if (menu.url === 'permisos') {

      this.permissions.edit(contextItem);

    }

  }

  ngOnInit() { 
    
    super.ngOnInit();    
  
  }

}